import { useEffect, useState } from "react";
import { Box, Flex, Text, Image, Heading } from "@chakra-ui/react";
import Hero from "./Hero";
import MyStory from "./MyStory";
import tiles from "../../assets/tiles.svg";
import dots from "../../assets/dots.svg";
import ai from "../../assets/ai.svg";
import play from "../../assets/play.svg";
import Footer from "./Footer";

const sections = [
  {
    id: 1,
    color: "#CDCDCD",
    title: "Interactive, Visual Learning",
    desc: "Learn advanced topics the way your brain loves—through simulations, visuals, and interactive tools. No more boring PDFs or passive videos.",
    image: play,
  },
  {
    id: 2,
    color: "#b8ffa1",
    title: "Bite-Sized Lessons",
    desc: "Understand complex ideas in just 15 minutes a day. Perfect for fast, deep learning—without overwhelm.",
    image: tiles,
  },
  {
    id: 3,
    color: "#FFDBC4",
    title: "Cross-Domain Thinking",
    desc: "Connect ideas across AI, Quantum Physics, Robotics, Blockchain, and more. Become a true polymath.",
    image: dots,
  },
  // {
  //   id: 4,
  //   color: "#FFDBC4",
  //   title: "No Degree Required",
  //   desc: "You don’t need a PhD. Just curiosity. Bellu.ai is for learners, makers, builders—not resume-chasers.",
  //   image: "/images/no-degree.png",
  // },
  {
    id: 5,
    color: "#FFDBC4",
    title: "AI On-Demand",
    desc: "Click any topic to get instant help—deep explanations, analogies, simplified versions, or even problem breakdowns. Like a personal tutor in every lesson.",
    image: ai,
  },
];

export default function SmoothScrollColorPage() {
  const [_, setBgColor] = useState(sections[0].color);

  useEffect(() => {
    const handleScroll = () => {
      const sectionHeight = window.innerHeight;
      const scrollY = window.scrollY - sectionHeight;
      const index = Math.floor(scrollY / sectionHeight);
      const nextIndex = Math.min(index + 1, sections.length - 1);
      const scrollOffset = scrollY % sectionHeight;
      const ratio = scrollOffset / sectionHeight;

      const from = hexToRgb(sections[index].color);
      const to = hexToRgb(sections[nextIndex].color);

      const blended = {
        r: Math.round(from.r + (to.r - from.r) * ratio),
        g: Math.round(from.g + (to.g - from.g) * ratio),
        b: Math.round(from.b + (to.b - from.b) * ratio),
      };

      const newColor = `rgb(${blended.r}, ${blended.g}, ${blended.b})`;
      setBgColor(newColor);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box>
      <Hero />
      <Box
        style={{
          backgroundColor: "rgb(24, 24, 24)",
          transition: "background-color 0.2s linear",
        }}
      >
        {sections.map((section, index) => (
          <Flex
            key={section.id}
            direction={{
              base: "column",
              md: index % 2 === 0 ? "row" : "row-reverse",
            }}
            mx={"auto"}
            align="center"
            justify="center"
            py={20}
            minH="100vh"
            gap={{ base: 5, md: "10rem" }}
          >
            <Box flex={1}>
              <Box
                px={"1rem"}
                maxW="25rem"
                ml={index % 2 == 0 ? "auto" : "none"}
              >
                {" "}
                <Heading
                  fontFamily="serif"
                  fontWeight={"bold"}
                  fontSize={{ base: "4xl", md: "6xl" }}
                  mb={4}
                >
                  {section.title}
                </Heading>
                <Text fontSize="lg">{section.desc}</Text>
              </Box>
            </Box>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              height={"100vh"}
              flex={1}
              width={{ base: "100%", md: "50vw" }}
            >
              <Image
                src={section.image}
                alt={section.title}
                h={{ base: "60vh", md: "100vh" }}
                width="100%"
                objectFit="cover"
              />
            </Box>
          </Flex>
        ))}
      </Box>
      <MyStory />
      {/* <EmailSignup /> */}
      <Footer />
    </Box>
  );
}

function hexToRgb(hex: string) {
  const shorthand = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthand, (_, r, g, b) => r + r + g + g + b + b);
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : { r: 0, g: 0, b: 0 };
}
